import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../../utils/api';
import { getPriceMemoEmailEndpoint } from '../../../common/endpoints';

export const getPriceMemoEmailApi = createApi(getPriceMemoEmailEndpoint, 'GET');

const GetPriceMemoEmail = createSlice({
  name: 'GetPriceMemoEmail',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getPriceMemoEmailApi.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getPriceMemoEmailApi.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(getPriceMemoEmailApi.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default GetPriceMemoEmail.reducer;